<template>
	<section
		:aria-labelledby="$source.id ? 'cog-' + $source.id : false"
		class="cog-section"
		:class="[
			'cog-col',
			colNumClass,
			{
				'is-error': showValidation,
				'cog-section--heading': $source.label && !labelHidden,
				['cog-field--' + fieldIndex]: fieldIndex,
				'cog-force-shown': forceShown,
				'hidden-label': labelHidden
			}
		]"
		:tabindex="showValidation ? 0 : -1"
		:aria-describedby="showValidation ? `cog-${$source.id}-error` : undefined"
		:aria-invalid="showValidation ? true : undefined"
	>
		<div class="cog-section__inner" :class="{'cog-section__inner--background ': background === 'main', 'cog-section__inner--background is-alternate': background === 'alternate', 'cog-section__inner--no-background ': background === 'none'}">
			<slot name="header">
				<h2 :is="'h' + Math.min(depth + 1, 4)" v-if="showLabel" :id="'cog-' + $source.id" class="cog-section__heading cog-heading">
					{{ $source.label }}
					<span v-if="showValidation" class="cog-offscreen">, {{ firstError.message }}</span>
				</h2>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<div v-if="$source.helptext && !$source.readonly" class="cog-helptext cog-html" v-html="$source.helptext"></div>
			</slot>
			<slot :entity="$source.value" :adapter="$source" :cols="cols"></slot>
		</div>
		<transition	name="cog-error-message">
			<div v-if="showValidation" :id="`cog-${$source.id}-error`" class="cog-error-message cog-error-message--container-footer" :aria-live="showLabel ? null : 'polite'" role="alert">{{ firstError.message }}</div>
		</transition>
	</section>
</template>

<script>
	import 'src/style/_error-message.scss';
	import 'src/style/_section.scss';

	import ValidatedSourcePath from '../mixins/validated-source-path';
	import headingDepth from '../mixins/heading-depth';
	import showLabel from '../mixins/show-label';
	import Col from './Col.vue';

	export default {
		name: 'CSection',
		mixins: [ValidatedSourcePath, Col, headingDepth, showLabel],
		props: {
			hideLabel: Boolean,
			background: {
				type: String,
				default: 'none',
				validator: value => ['none', 'main', 'alternate'].includes(value)
			},
			fieldIndex: { type: String, default: null },
			forceShown: { type: Boolean, default: false }
		}
	};
</script>
